import en from './TranslationsEn'
import jp from './TranslationsJp'
import fr from './TranslationsFr'
import cn from './TranslationsCn'
import kr from './TranslationsKr'
import tw from './TranslationsTw'

// jsonを結合する
var localization = Object.assign(en, jp, fr, cn, kr, tw)

export { localization }